/* UNSCRIPTED 60-second recall test, part 2 of 4: the memory tests (spatial grid, number sequence with a distraction step) and the loader. */

/* Spatial test: look at items on a grid, then tap where each one sat */
function readyScreen(label, text, next) {
  mount(`<section class="ready"><p class="taskh">${label}</p><h2>${text}</h2></section>`);
  later(next, 1300);
}
function gridTest(o) {
  const positions = shuffle([...Array(CELLS).keys()]).slice(0, o.items.length);
  const where = {}; o.items.forEach((n, i) => { where[n] = positions[i]; });
  const cells = [...Array(CELLS).keys()].map(c => {
    const name = o.items.find(n => where[n] === c);
    if (o.places) return `<div class="cell place${name ? " item" : ""}">${name || ""}<span class="pl">${PLACES[c]}</span></div>`;
    return `<div class="cell${name ? " item" : ""}">${name || NB}</div>`;
  }).join("");
  const list = o.places ? `<ul class="plist">${o.items.map(n => `<li>${n} &rarr; ${PLACES[where[n]]}</li>`).join("")}</ul><p class="small">Picture each item on its place, in an odd way. A PEN stuck in the toaster.</p>` : "";
  mount(`
    <section>
      <p class="taskh">${o.label}</p>
      <h2 class="ask">${o.places ? "Give each item a place." : "Remember where each item sits."}</h2>
      <p class="timer" aria-hidden="true" id="timer">${o.look}</p>
      <div class="grid">${cells}</div>
      ${list}
    </section>`);
  let left = o.look; const t = document.getElementById("timer");
  timer = setInterval(() => { left -= 1; t.textContent = Math.max(left, 0); if (left <= 0) { clearInterval(timer); timer = null; gridRecall(o, where); } }, 1000);
}
function gridRecall(o, where) {
  const order = shuffle(o.items); let k = 0, correct = 0; const used = {}, picks = {};
  mount(`
    <section>
      <p class="taskh">${o.label}</p>
      <h2 class="ask" id="ask"></h2>
      <p class="micro" style="text-align:left;margin:0">Tap the square where it was.</p>
      <div class="grid" id="rg"></div>
    </section>`, "#ask");
  const ask = document.getElementById("ask"), rg = document.getElementById("rg");
  const label = () => { ask.textContent = "Where was the " + order[k] + "?"; };
  for (let c = 0; c < CELLS; c++) {
    const b = document.createElement("button");
    b.type = "button"; b.className = "cell" + (o.places ? " place" : "");
    b.innerHTML = o.places ? `<span class="pl">${PLACES[c]}</span>` : NB;
    b.setAttribute("aria-label", o.places ? PLACES[c] : "Square " + (c + 1));
    b.addEventListener("click", () => {
      if (used[c] || k >= order.length) return;
      used[c] = 1; b.disabled = true; b.classList.add("used");
      b.innerHTML = o.places ? order[k] + `<span class="pl">${PLACES[c]}</span>` : order[k];
      picks[order[k]] = c;
      if (where[order[k]] === c) correct += 1;
      k += 1;
      if (k >= order.length) later(() => o.done({ items: o.items, where, picks, correct }), 450); else label();
    });
    rg.appendChild(b);
  }
  label();
}
function spatial() {
  readyScreen("Memory test 1 of 2", "Get ready to remember positions.", () => gridTest({
    items: SPATIAL_ITEMS, look: LOOK, label: "Memory test 1 of 2",
    done(info) { st.sInfo = info; st.sScore = info.correct; track("quiz_q04", { question: "spatial", correct: info.correct }); go("digits"); }
  }));
}

/* Numbers test: see a sequence, key in 9 to 0 (or 0 to 9) as a distraction, then key in the sequence */
function keypadHtml(withBack) {
  const k = n => `<button class="key" type="button" data-k="${n}" aria-label="${n}">${n}</button>`;
  return `<div class="keypad" id="kp">${[1, 2, 3, 4, 5, 6, 7, 8, 9].map(k).join("")}${withBack ? `<button class="key fn" type="button" data-k="back" aria-label="Delete">&#9003;</button>` : `<span class="key blank"></span>`}${k(0)}<span class="key blank"></span></div>`;
}
function bindKeys(onKey) {
  document.querySelectorAll("#kp .key[data-k]").forEach(b => b.addEventListener("click", () => onKey(b.dataset.k)));
  st.keyHandler = onKey;
}
function makeSeq(n) {
  for (;;) {
    const s = Array.from({ length: n }, () => Math.floor(Math.random() * 10));
    const dup = s.some((d, i) => i && d === s[i - 1]);
    const run = s.some((d, i) => i > 1 && Math.abs(d - s[i - 1]) === 1 && s[i - 1] - s[i - 2] === d - s[i - 1]);
    if (!dup && !run) return s;
  }
}
function digits() {
  const seq = makeSeq(DIGITS), down = Math.random() < 0.5;
  const order = down ? [9, 8, 7, 6, 5, 4, 3, 2, 1, 0] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  readyScreen("Memory test 2 of 2", "Get ready to remember a number.", () => {
    mount(`
      <section>
        <p class="taskh">Memory test 2 of 2</p>
        <h2 class="ask">Remember this number.</h2>
        <div class="digits" aria-label="${seq.join(" ")}">${seq.join("")}</div>
        <div class="count" aria-hidden="true" id="count"><i></i></div>
      </section>`);
    requestAnimationFrame(() => requestAnimationFrame(() => { const c = document.getElementById("count"); if (c) c.classList.add("run"); }));
    later(distract, DIGIT_LOOK * 1000);
  });

  function distract() {
    let idx = 0;
    mount(`
      <section>
        <p class="taskh">Memory test 2 of 2</p>
        <h2 class="ask">Now tap ${down ? "9 down to 0" : "0 up to 9"}, in order.</h2>
        <div class="trail" id="trail" aria-live="off"></div>
        ${keypadHtml(false)}
      </section>`);
    const trail = document.getElementById("trail");
    bindKeys(key => {
      if (!/^\d$/.test(key)) return;
      if (+key === order[idx]) {
        idx += 1; const s = document.createElement("span"); s.textContent = key; trail.appendChild(s);
        if (idx >= order.length) later(recall, 350);
      } else { trail.classList.remove("shake"); void trail.offsetWidth; trail.classList.add("shake"); }
    });
  }

  function recall() {
    const typed = [];
    mount(`
      <section>
        <p class="taskh">Memory test 2 of 2</p>
        <h2 class="ask">Now key in the number you saw.</h2>
        <div class="slots" id="slots" aria-live="off">${Array.from({ length: DIGITS }, () => "<span></span>").join("")}</div>
        ${keypadHtml(true)}
      </section>`, ".ask");
    const slots = [...document.querySelectorAll("#slots span")];
    const paint = () => slots.forEach((s, i) => { s.textContent = typed[i] != null ? typed[i] : ""; s.classList.toggle("on", i === typed.length); });
    paint();
    bindKeys(key => {
      if (key === "Backspace" || key === "back") { typed.pop(); paint(); return; }
      if (!/^\d$/.test(key) || typed.length >= DIGITS) return;
      typed.push(+key); paint();
      if (typed.length === DIGITS) {
        st.keyHandler = null;
        const correct = typed.filter((d, i) => d === seq[i]).length;
        st.dInfo = { seq, typed: typed.slice(), correct }; st.dScore = correct;
        track("quiz_q05", { question: "digits", correct, direction: down ? "9-0" : "0-9" });
        later(() => go("q4"), 400);
      }
    });
  }
}

/* Loader, then the email step (or straight to the result for someone who already gave their email and retook the test) */
function loader() {
  mount(`
    <section class="loader">
      <h2>Scoring your answers&hellip;</h2>
      <ul class="ticks">
        <li><span class="d">&#10003;</span>Checking your recall habits</li>
        <li><span class="d">&#10003;</span>Scoring your memory tests</li>
        <li><span class="d">&#10003;</span>Building your plan</li>
      </ul>
    </section>`);
  [...$screen.querySelectorAll(".ticks li")].forEach((li, n) => setTimeout(() => li.classList.add("on"), 300 + n * 420));
  st.done = true;
  track("quiz_complete", { quiz_score: habit() + st.sScore + st.dScore, habit: habit(), spatial: st.sScore, digits: st.dScore });
  later(() => go(st.unlocked ? "result" : "gate"), 1750);
}

function trick() {
  track("quiz_trick_start");
  gridTest({ items: TRICK_ITEMS, look: LOOK_TRICK, label: "Experiment · with places", places: true,
    done(info) { st.trick = { correct: info.correct }; track("quiz_trick_done", { correct: info.correct }); go("result"); later(() => { const e = document.getElementById("exp"); if (e) e.scrollIntoView({ block: "start" }); }, 80); } });
}